// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see AudienceEnterCompleteEvent
 */
export var AudienceEnterComplete = function (_a) {
    var segmentJourneyStep = _a.segmentJourneyStep, personaAudienceKey = _a.personaAudienceKey;
    return ({
        name: "Audience Enter Complete",
        parameters: {
            cdf_entity: "Audience",
            cdf_action: "Enter",
            segment_journey_step: segmentJourneyStep !== undefined && segmentJourneyStep !== null ? segmentJourneyStep.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            persona_audience_key: personaAudienceKey !== undefined && personaAudienceKey !== null ? personaAudienceKey.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AudienceExitCompleteEvent
 */
export var AudienceExitComplete = function (_a) {
    var segmentJourneyStep = _a.segmentJourneyStep, personaAudienceKey = _a.personaAudienceKey;
    return ({
        name: "Audience Exit Complete",
        parameters: {
            cdf_entity: "Audience",
            cdf_action: "Exit",
            segment_journey_step: segmentJourneyStep !== undefined && segmentJourneyStep !== null ? segmentJourneyStep.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            persona_audience_key: personaAudienceKey !== undefined && personaAudienceKey !== null ? personaAudienceKey.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
